import { useImage } from "hooks/useImage";
import React, { FC } from "react";
import { ImageSkeleton } from "components/common/Skeleton";

const Image: FC<{
  errorMessage?: string;
  src?: string;
  alt?: string;
  className?: string;
  style?: React.CSSProperties;
  [key: string]: any;
}> = ({ errorMessage, ...rest }) => {
  const { isError, isLoading, onError, onLoad } = useImage();

  return (
    <>
      <img
        {...rest}
        onError={onError}
        onLoad={onLoad}
        style={{ opacity: isError ? 0 : 1 }}
      />
      {isLoading && (
        <ImageSkeleton />
      )}
      {errorMessage && isError && <h5>{errorMessage}</h5>}
    </>
  );
};

export default Image;
